// import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
// import { DateFormatter } from '../../components/Grid/formatters/DateFormater';
// import CurrencySummary from '../../components/Grid/CurrencySummary';
import RouteEditor from '.';

export default [
  {
    key: 'representativeId',
    name: 'Representante',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 110,
  },
  {
    key: 'cityName',
    name: 'Cidade',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 110,
  },
  {
    key: 'stateCode',
    name: 'Estado',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 80,
  },
  {
    key: 'population',
    name: 'População',
    type: 'number',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 80,
  },
  {
    key: 'route',
    name: 'Rota',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    editable: true,
    // width: 120,
    editor: RouteEditor,
  },
];
